import { Link } from 'react-router-dom';
import { NavigationItem as NavItem } from '../../hooks/useNavigation';

interface NavigationItemProps {
  item: NavItem;
  isActive: boolean;
  isAccessible: boolean;
  isSidebarCollapsed: boolean;
  onClick: (e: React.MouseEvent, item: NavItem) => void;
}

export function NavigationItem({
  item,
  isActive,
  isAccessible,
  isSidebarCollapsed,
  onClick,
}: NavigationItemProps) {
  const getItemClasses = () => {
    const baseClasses = `
      flex items-center px-3 py-2 text-sm rounded-lg
      ${isSidebarCollapsed ? 'justify-center px-0' : ''}
      group
    `;

    if (isActive) {
      return `${baseClasses} ${
        isSidebarCollapsed
          ? 'bg-[#E34290] dark:bg-[#E34290] text-white dark:text-white'
          : 'bg-theme-light-bg dark:bg-theme-dark-bg text-[#E34290] dark:text-[#E34290]'
      }`;
    }

    if (isAccessible) {
      return `${baseClasses} text-theme-light-text-secondary dark:text-theme-dark-text-secondary hover:bg-theme-light-bg dark:hover:bg-theme-dark-bg hover:text-[#E34290] dark:hover:text-[#E34290]`;
    }

    return `${baseClasses} text-gray-400 dark:text-gray-600 cursor-pointer hover:bg-theme-light-bg dark:hover:bg-theme-dark-bg`;
  };

  const getIconClasses = () => {
    const baseClasses = isSidebarCollapsed ? 'h-5 w-5' : 'h-4 w-4 mr-3';

    if (isActive) {
      return `${baseClasses} ${isSidebarCollapsed ? 'text-white' : 'text-[#E34290]'}`;
    }

    return baseClasses;
  };

  return (
    <div className="mb-1">
      <Link
        to={item.href}
        onClick={(e) => onClick(e, item)}
        className={getItemClasses()}
        title={isSidebarCollapsed ? item.name : isAccessible ? undefined : 'Available in Pro'}
        data-ph-capture-attribute={`nav-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <item.icon className={getIconClasses()} />
        <span className={`${isSidebarCollapsed ? 'hidden' : ''} relative flex-1`}>
          {item.name}
          {!isAccessible && !isSidebarCollapsed && (
            <span className="absolute left-0 -bottom-6 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
              Available in Pro
            </span>
          )}
        </span>
        {item.teaser && !isSidebarCollapsed && (
          <div className="ml-2 px-2 py-0.5 bg-gradient-to-r from-[#E34290] to-[#F472B6] text-white text-xs font-semibold rounded-full shadow-sm">
            BETA
          </div>
        )}
      </Link>
    </div>
  );
}
